import React, { useState } from "react";
import { Button, Container, Row, Col, Card, Form } from "react-bootstrap";
import { Circle, CheckCircle, XCircle } from "react-bootstrap-icons";

const Address = ({ address, selected, i, selectAddr, deleteAddr, addAddr }) => {
  return (
    <Col>
      <Card>
        <Card.Body>
          {address?.address ? (
            <Row
              onClick={() => {
                selectAddr(i);
              }}
            >
              <Col xs={1}>{selected ? <CheckCircle /> : <Circle />}</Col>
              <Col className="ms-3">
                <Row>{address.address}</Row>
                <Row>{address.floor}</Row>
              </Col>
              <Col xs={1} className="me-2">
                <XCircle className="" onClick={() => deleteAddr(i)} />
              </Col>
            </Row>
          ) : (
            <>
              <NewAddress addAddr={addAddr} />
            </>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

const NewAddress = ({ addAddr }) => {
  const [revealed, setRevealed] = useState(false);
  const [values, setValues] = useState({
    address: "",
    floor: "",
  });

  const handleChange = (name) => (event) => {
    setValues({
      ...values,
      [name]: event.target.value.replace(/[^a-zčćžšđ0-9 .,-/]/gi, ""),
    });
  };

  return (
    <>
      {revealed ? (
        <>
          <Row>
            <Form.Control
              id="address"
              placeholder="Address"
              className=""
              value={values.address}
              onChange={handleChange("address")}
            />
          </Row>
          <Row className="mt-2">
            <Form.Control
              id="floor"
              placeholder="Floor"
              className=""
              value={values.floor}
              onChange={handleChange("floor")}
            />
          </Row>
          <Row className="m-auto justify-content-around">
            <Col>
              <Button
                variant="outline-primary"
                style={{ color: "red" }}
                size="sm"
                onClick={() => {
                  setRevealed(false);
                  setValues({
                    address: "",
                    floor: "",
                  });
                }}
              >
                CANCEL
              </Button>
            </Col>
            <Col>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => {
                  addAddr(values);
                  setRevealed(false);
                  setValues({
                    address: "",
                    floor: "",
                  });
                }}
              >
                ADD
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        <h5
          className="text-center"
          style={{ color: "grey" }}
          onClick={() => setRevealed(true)}
        >
          Add new
        </h5>
      )}
    </>
  );
};

export default Address;
